import { render } from "./ScanTable.vue?vue&type=template&id=48753d25&scoped=true"
import script from "./ScanTable.vue?vue&type=script&lang=js"
export * from "./ScanTable.vue?vue&type=script&lang=js"

import "./ScanTable.vue?vue&type=style&index=0&id=48753d25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48753d25"]])

export default __exports__